module.exports = __webpack_public_path__ + "media/src/assets/welcome_report_screen-c5359fdaddea4f9e288e1639fa56c0ea.png";